module.exports = __webpack_public_path__ + "static/media/nine.4d1fcf64.jpg";